/*
curl -i -X POST -H "Content-Type: application/json"
"http://127.0.0.1:4000/api/0.2/diagnostics/clientErrors"
-d '{
"ncWalletAddress": "0x123456...",
"clientId": "ccm32asdf",
"error": "filepath1: 10: error description\n\tdir/filepath2: 20",
"additionalInfo": {"key 1": "value 1", "key 2": "value 2"}}'
*/
import axios, { AxiosError } from "axios";
import axiosRetry from "axios-retry";
import { baseUrl as configBaseUrl, apiVersion } from "../dwclient/config";
const baseUrl = process.env.DWINITY_BACKEND ?? configBaseUrl;
export function createEmptyLogsAndVars(startingPoint) {
    const logsAndVars = [];
    if (startingPoint) {
        newPlace(logsAndVars, startingPoint);
    }
    return logsAndVars;
}
export class ReportingError extends Error {
    logsAndVars;
    constructor(messageOrCause, logsAndVars) {
        super(messageOrCause instanceof Error ? messageOrCause.message : messageOrCause);
        if (messageOrCause instanceof Error) {
            this.cause = messageOrCause;
        }
        this.logsAndVars = logsAndVars;
        this.name = "ReportingError";
    }
}
export async function dryDwReportError(ncWalletAddress, clientId, error, additionalInfo) {
    const reportObject = makeReportObject(ncWalletAddress, clientId, error, additionalInfo);
    //console.log("dryDwReportError send:", reportObject);
}
export async function dwReportError(ncWalletAddress, clientId, error, additionalInfo) {
    try {
        const reportObject = makeReportObject(ncWalletAddress, clientId, error, additionalInfo);
        //console.log("dwReportError send:", reportObject);
        const urlPath = `/api/${apiVersion}/diagnostics/client_errors`;
        const url = baseUrl + urlPath;
        const headers = {
            "Content-Type": "application/json",
        };
        const client = axios.create({ baseURL: baseUrl });
        const retrySeconds = [0, 5, 15, 30, 60, 120, 240, 480]; // how many seconds after first try
        axiosRetry(client, {
            retries: retrySeconds.length - 1,
            retryDelay: (retryCount) => {
                const diffSeconds = retrySeconds[retryCount] - retrySeconds[retryCount - 1];
                return diffSeconds * 1000;
            },
            retryCondition: (error) => true,
        });
        const response = await client.post(urlPath, reportObject, { headers });
        //console.log("dwReportError response:", response);
    }
    catch (reportingError) {
        console.warn("Failed to report error to backend:", reportingError);
    }
}
export function concatLogsAndVars(first, second) {
    return [...first, ...second];
}
// TODO localstorage is part of this
function makeReportObject(ncWalletAddress, clientId, error, additionalInfo) {
    let errorToSend;
    if (error instanceof Error) {
        errorToSend = error.message + "\n" + error.stack;
    }
    else {
        errorToSend = JSON.stringify(error);
    }
    if (additionalInfo instanceof Array) {
        additionalInfo = { logsAndVars: additionalInfo };
    }
    const reportObject = {
        ncwa: ncWalletAddress ?? "N/A",
        clientId: clientId ?? "N/A",
        error: errorToSend ?? "N/A",
        additionalInfo,
    };
    return reportObject;
}
export function collectLog(logsAndVars, message, param1, param2, param3) {
    const combinedMessage = message +
        (param1 !== undefined ? " " + param1 : "") +
        (param2 !== undefined ? " " + param2 : "") +
        (param3 !== undefined ? " " + param3 : "");
    logsAndVars.push({ log: combinedMessage });
    return combinedMessage;
}
export function collectAndPrintToConsoleLog(logsAndVars, message, param1, param2, param3) {
    const combinedMessage = collectLog(logsAndVars, message, param1, param2, param3);
    //console.log(combinedMessage);
}
export function recordVariable(logsAndVars, key, value) {
    let storedValue;
    if (value instanceof Set) {
        storedValue = transformSet(value);
    }
    else if (value instanceof File) {
        storedValue = getFileData(value);
    }
    else if (typeof value === "bigint") {
        storedValue = value.toString();
    }
    else {
        storedValue = JSON.stringify(value);
    }
    logsAndVars.push({ [key]: storedValue });
}
export async function recordPotentialAxiosError(logsAndVars, error) {
    if (error instanceof AxiosError) {
        recordVariable(logsAndVars, "axios error status", error.status);
        let responseDataText;
        if (error.response?.data instanceof Blob) {
            responseDataText = await error.response?.data.text();
        }
        else if (error.response?.data !== undefined) {
            responseDataText = JSON.stringify(error.response.data); //.toString();
        }
        recordVariable(logsAndVars, "axios error data", responseDataText);
    }
}
export function newPlace(logsAndVars, place) {
    logsAndVars.push({ place });
}
function transformSet(element) {
    return Array.from(element);
}
function getFileData(file) {
    return file.name + " (" + file.size + " bytes, " + file.type + ")";
}
